<template>
  <div class="my-item">
    <div class="custom-wrap">
      <template v-if="list && list.length">
        <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
          <template slot-scope="{ row, index }" slot="name">
            <span class="brand">{{ row.name }}</span>
          </template>
          <template slot-scope="{ row, index }" slot="showIndex">{{
            row.showIndex
          }}</template>
          <template slot-scope="{ row, index }" slot="action">
            <span style="color: #1890ff; cursor: pointer" @click="editShow(row)"
              >编辑</span
            >
            <span style="display: inline-block; padding: 0 5px">|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00; cursor: pointer">删除</span>
            </Poptip>
          </template>
        </Table>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <supplyAdd
      :show="show"
      @finish="init()"
      @close="show = false"
      :options="options"
      :correspondArea="correspondArea"
      :modelTitle="modelTitle"
    />
  </div>
</template>

<script>
import supplyAdd from "../components/area-add.vue";
// import supplyEdit from "../components/supply-edit.vue";
import { mapActions } from "vuex";
import axios from "axios";
import qs from "qs";

import sha256 from "crypto-js/sha256"; // SHA256哈希加密
import Base64 from "crypto-js/enc-base64";
import { randomRange, encryptByMd5 } from "@/utils/encrypt";

export default {
  // 主办设置
  name: "host-set",
  data() {
    return {
      list: null,
      edit: false,
      editInfo: false,
      show: false,
      options: {},
      modelTitle: "",
      columns1: [
        {
          title: "展区名称",
          slot: "name",
          key: "name",
          align: "center",
        },
        {
          title: "对应展区名称",
          key: "thirdPartyZoneName",
          align: "center",
        },
        {
          title: "光地价格/RMB",
          key: "zonePrice",
          align: "center",
        },
        {
          title: "标摊价格/USD",
          key: "zonePcount",
          align: "center",
        },
        {
          title: "语言",
          key: "typeLanguage",
          align: "center",
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
        },
      ],
      expires_in: 0,
      token: "",
      correspondArea: [],
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
  },
  created() {
    this.init();

    // 后端返回的是7200s，当过期时间小于10分钟时，重新获取token
    this.tokenSaas();
  },
  components: {
    supplyAdd,
    // supplyEdit,
  },
  methods: {
    ...mapActions({
      PjNameGroupGetAll: "hostSetModule/PjNameGroupGetAll",
      PjNameGroupDel: "hostSetModule/PjNameGroupDel",
      PjNameGroupPost: "hostSetModule/PjNameGroupPost",
    }),
    async tokenSaas() {
      let header = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      let req = {
        client_id: "MYDev-YPVMbMBCaNCxMZlxjdnvEmZLDacXec",
        client_secret: "pdLudeaW4OLZiqt8U7hXoqI5W7BxQujBSqXG",
        grant_type: "client_credentials",
        scope: "open_api",
      };
      let res = await axios.post(
        "https://api-ecrm.reed-sinopharm.com/connect/token",
        qs.stringify(req),
        header
      );
      if (res.data.access_token) {
        this.token = res.data.access_token;
        this.expires_in = res.data.expires_in;
        this.getAreaAll(res.data.access_token);
      }
    },
    async getAreaAll(token) {
      let randomTxt = randomRange(6);
      let timeTxt = Math.floor(Date.now() / 1000);
      let client_id = "MYDev-YPVMbMBCaNCxMZlxjdnvEmZLDacXec";
      let client_secret = "pdLudeaW4OLZiqt8U7hXoqI5W7BxQujBSqXG";
      let sha256Txt = sha256(client_secret).toString(Base64);
      let signTTT = `x-adprv-client-id=${client_id}\\\\x-adprv-client-secret=${sha256Txt}\\\\x-adprv-noncestr=${randomTxt}\\\\x-adprv-timestamp=${timeTxt}`;
      let sign2 = encryptByMd5(signTTT);
      const noncestr = randomTxt ? { "x-adprv-noncestr": randomTxt } : {};
      const timestamp = timeTxt ? { "x-adprv-timestamp": timeTxt } : {};
      const sign = sign2 ? { "x-adprv-sign": sign2 } : {};
      const projectId = this.exhibitionInfo.projectId
        ? { "x-project-id": this.exhibitionInfo.projectId }
        : {};
      const exhibitionId = this.exhibitionInfo.thirdPartyExhibitionId
        ? { "x-exhibition-id": this.exhibitionInfo.thirdPartyExhibitionId }
        : {};
      let header = {
        headers: {
          Authorization: `Bearer ${token}`,
          ...noncestr,
          ...timestamp,
          ...sign,
          ...projectId,
          ...exhibitionId,
        },
      };
      let res = await axios.get(
        "https://api-ecrm.reed-sinopharm.com/api/v1/exhibition-area/all",
        header
      );
      if (res.data) {
        this.correspondArea = res.data || [];
        console.log(this.correspondArea, "000000");
      }
    },
    async init() {
      let opt = {
        PageSize: 999,
        PageIndex: 1,
     sorts: [{ "propertyName": "showIndex", "ascending": true }],
        Wheres: {
          type: 0,
          wheres: {
            WhereGroupOperator: 0,
            Predicates: [
              {
                type: 1,
                wheres: {
                  WhereOperator: 6,
                  Label: "exhibitionId",
                  Value: `%${this.exhibitionInfo.id}%`,
                },
              },
            ],
          },
        },
      };

      let listData = await this.PjNameGroupGetAll(opt);
      this.list = listData.items || [];
    },
    async delItem(item) {
      let result = await this.PjNameGroupDel(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd() {
      // 新增
      this.show = true;
      this.modelTitle = "新增";
      this.options = {
        model: null,
        msg: null,
      };
    },
    editShow(item) {
      // 编辑
      this.show = true;
      this.modelTitle = "编辑";
      this.options = {
        model: "edit",
        msg: item,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.custom-wrap {
  margin: 0 auto;
  min-height: 500px;
}
</style>
